import * as React from 'react';

import styles from './why-devextreme-react.module.scss';

export default () => (
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <h2 className={styles.title}>
          Why DevExtreme Reactive?
        </h2>
      </div>
    </div>
  </div>
);
